import { render, staticRenderFns } from "./matricula_niveles.vue?vue&type=template&id=05c5a404"
import script from "./matricula_niveles.vue?vue&type=script&lang=js"
export * from "./matricula_niveles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports